export default __webpack_public_path__ + "static/media/Background_00057.48b65641.png";